import { typedStyles } from '@/utils/styleUtils';

export const styles = typedStyles({
  modal: {
    width: 'min(80%, 1184px)',
    height: '80%',
    overflow: 'hidden',
  },

  root: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      tablet: '392px 1fr',
    },
  },

  sidePane: ({ palette, spacing }) => ({
    gap: 3,
    padding: spacing(9, 8, 6),
    borderRight: `1px solid ${palette.custom.divider}`,
    placeContent: 'start',
    overflow: 'auto',

    display: {
      xs: 'none',
      tablet: 'grid',
    },
  }),

  sidePaneTitle: {
    marginBottom: 3,
  },
});
